// Golem construction (MOB-2 golem, M13.1). PURE (ENG-1).
//
// When a carved pumpkin is placed on the right frame, it becomes a golem: the
// frame blocks are consumed and a persistent golem spawns. Snow golem = a pumpkin
// atop two stacked snow blocks; iron golem = a pumpkin atop an iron T (a body +
// base column with two arms flanking the body on either the x or z axis).
export interface GolemBuild {
  type: 'iron_golem' | 'snow_golem';
  /** Frame cells (incl. the pumpkin) to clear to air. */
  clear: Array<[number, number, number]>;
  /** Feet block position to spawn the golem at (caller centres with +0.5). */
  spawn: [number, number, number];
}

type BlockAt = (x: number, y: number, z: number) => string;

/** Test the frame with the pumpkin at (x,y,z); returns the golem to build, or null. */
export function checkGolem(at: BlockAt, x: number, y: number, z: number): GolemBuild | null {
  if (at(x, y, z) !== 'carved_pumpkin') return null;

  // Snow golem: pumpkin on two stacked snow blocks.
  if (at(x, y - 1, z) === 'snow_block' && at(x, y - 2, z) === 'snow_block') {
    return { type: 'snow_golem', clear: [[x, y, z], [x, y - 1, z], [x, y - 2, z]], spawn: [x, y - 2, z] };
  }

  // Iron golem: pumpkin on a body + base iron column with two flanking arms.
  if (at(x, y - 1, z) === 'iron_block' && at(x, y - 2, z) === 'iron_block') {
    for (const [ax, az] of [[1, 0], [0, 1]] as const) {
      const armA: [number, number, number] = [x - ax, y - 1, z - az];
      const armB: [number, number, number] = [x + ax, y - 1, z + az];
      if (at(armA[0], armA[1], armA[2]) === 'iron_block' && at(armB[0], armB[1], armB[2]) === 'iron_block') {
        return { type: 'iron_golem', clear: [[x, y, z], [x, y - 1, z], [x, y - 2, z], armA, armB], spawn: [x, y - 2, z] };
      }
    }
  }
  return null;
}
